import type { OnInit } from '@angular/core';
import { Component, HostBinding, Input } from '@angular/core';
import {
  getContentListValues,
  getFieldValue,
  getItemLinkFieldValue,
} from '@core/jss-utils';
import { InnogyComponentRendering } from '@core/jss-models';
import type { LinkField } from '@sitecore-jss/sitecore-jss-angular';
import { toScrollAnchorId } from '@innogy/utils-deprecated';

import type { JumbotronImagePath, JumbotronModel } from '../jumbotron.model';

@Component({
  selector: 'wl-jumbotron-container',
  templateUrl: './jumbotron-container.component.html',
  // TODO: Temp solution to fix styling in experience editor (https://gitlab.essent.nl/Sitecoreplus/Frontend/issues/31)
  styleUrls: [
    '../jumbotron.component.essent.scss',
    '../jumbotron.component.ed.scss',
  ],
})
export class JumbotronContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  item?: JumbotronModel;

  @HostBinding('attr.id') get id() {
    if (this.rendering?.uid) {
      return toScrollAnchorId(this.rendering.uid);
    }
    return '';
  }

  ngOnInit() {
    this.item = this.renderingToModel(this.rendering);
  }

  private renderingToModel(
    rendering: InnogyComponentRendering | undefined
  ): JumbotronModel {
    if (rendering == null || rendering.fields == null) {
      return {};
    }

    const title = getFieldValue<string>(rendering.fields, 'title');
    const subtitle = getFieldValue<string>(rendering.fields, 'subtitle');
    const imagePath = getFieldValue<JumbotronImagePath>(
      rendering.fields,
      'imgpath'
    );
    const buttonText = getFieldValue<string>(rendering.fields, 'buttontext');
    const url = getFieldValue<LinkField>(rendering.fields, 'url');

    const brandBoxClasses = getContentListValues(
      rendering.fields,
      'brandboxclasses'
    );

    const contentClasses = getItemLinkFieldValue(
      rendering.fields,
      'contentclasses'
    );

    const titleClasses = getItemLinkFieldValue(
      rendering.fields,
      'titleclasses'
    );

    const subtitleClasses = getItemLinkFieldValue(
      rendering.fields,
      'subtitleclasses'
    );

    const buttonClasses = getItemLinkFieldValue(
      rendering.fields,
      'buttonclasses'
    );

    return {
      title,
      subtitle,
      imagePath,
      buttonText,
      brandBoxClasses,
      contentClasses,
      titleClasses,
      subtitleClasses,
      buttonClasses,
      url: url ? url.href : '',
    };
  }
}
